/* eslint-disable max-len */
import Axios from 'axios';
import store from '../store';
import router from '../router';
import Names from '../router/names';

const apiFactory = Axios.create({
	baseURL: process.env.VUE_APP_API_URL,
	// baseURL: 'https://baboon-1125.appspot.com/_ah/api',
	headers: {
		'Content-Type': 'application/json',
		applicationVersion: 'POS_WEB',
	},
});

apiFactory.interceptors.request.use(
	(config) => {
		const token = store.getters['token'];
		const isGoogleMapRequest = config.url.indexOf('maps.googleapis.com') > -1;
		if (token && !isGoogleMapRequest) {
			config.headers.Authorization = token;
		}
		return config;
	},
	(error) => {
		if (error.response.status === 401) {
			store.dispatch('logout');
		}
		return Promise.reject(error.response.data);
	}
);

apiFactory.interceptors.response.use(
	(response) => {
		const { statusMessage } = response.data;
		if (statusMessage && statusMessage.status === 401) {
			store.dispatch('logout');
			router.push({ name: Names.Login });
		}
		if (statusMessage && !statusMessage.success) {
			return Promise.reject(statusMessage);
		}
		return Promise.resolve(response);
	},
	(error) => {
		if (error.response && error.response.status === 401) {
			store.dispatch('logout');
			router.push({ name: Names.Login });
		}
		return Promise.reject(error.response ? error.response.data : error);
	}
);

export const to = (axiosPromise) =>
	new Promise((resolve) => {
		axiosPromise
			.then((response) => {
				resolve({
					data: response.data,
					error: null,
					message: null,
					status: 200,
				});
			})
			.catch((error) => {
				resolve({
					error: error.response ? error.response.data : true,
					message: error.message,
					status: error.response && error.response.status,
				});
			});
	});

export default apiFactory;
